/**
 * @fileoverview Header component.core
 *
 */
'use strict';
// React Import
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
// Library Import
import _ from 'lodash';
import mobiscroll from '../../lib/mobiscroll/forms.react';
// Config Import
import AppConfig from '../../AppConfig';
// Core Import
import HeaderMenu from '../core/HeaderMenu';
import Loading from './Loading';
import { os } from '../../lib/mobiscroll/util/platform';
// Collection Import
import AuthenticationCollection from '../../collection/AuthenticationCollection';
// Util Import
import * as ConstUtil from '../../util/ConstUtil';

/**
 * センタ―ヘッダーコンポーネント
 *
 * @class Header
 * @extends {Component}
 */
class Header extends Component {
  constructor(props) {
    super(props);
    this.collection = new AuthenticationCollection();
    _.bindAll(
      this,
      'clickHamburgerMenu',
      'clickButton',
      'logout',
      'getRefHeader'
    );
  }

  /**
   * Component 更新前処理
   *
   * @memberof Header
   */
  componentDidUpdate() {
    this.props.setHeight(this.refHeader.offsetHeight);
  }

  /**
   * ログアウト
   *
   * @memberof Header
   */
  logout() {
    Loading.show();
    this.collection.logout(
      {
        success: this.successLogout.bind(this),
        failure: this.failureLogout.bind(this)
      },
      {}
    );
  }

  /**
   * ログアウト成功
   *
   * @memberof Header
   */
  successLogout() {
    this.toPortalLogin();
  }

  /**
   * ログアウト失敗
   *
   * @memberof Header
   */
  failureLogout(err) {
    // レスポンスが存在しない場合
    if (_.isEmpty(err.response)) {
      this.toPortalLogin();
      return;
    }
    // 認証エラーの場合
    if (
      err.response.status ===
      ConstUtil.Common.HTTP_STATUS_CODE_LIST.UNAUTHORIZED
    ) {
      this.toPortalLogin();
      return;
    }
    Loading.hide();
    // メッセージ画面に遷移
    this.props.history.push(
      ConstUtil.Common.COMPONENT.MESSAGE.URL +
        this.createQueryParam([
          {
            key: 'main',
            value: 'COMMON.ID701'
          }
        ])
    );
  }

  /**
   * ログイン画面に遷移
   *
   * @memberof Header
   */
  toPortalLogin() {
    // ローカルストレージクリア
    localStorage.clear();
    Loading.hide();
    // ポータルサイト ログイン画面遷移
    window.location.href =
      AppConfig.httpScheme +
      AppConfig.portalDomain +
      AppConfig.appPortNumber +
      ConstUtil.Common.PORTAL_URL_LIST.LOGIN;
  }

  /**
   * ボタンクリック
   *
   * @memberof Header
   */
  clickButton() {
    this.props.history.push(ConstUtil.Common.COMPONENT.MY_PAGE.URL);
  }

  /**
   *  タイトル要素の描画
   *
   * @returns {Object} タイトル要素
   * @memberof Header
   */
  renderSystemTitle() {
    return <div className="system-title">{ConstUtil.Message.COMMON.ID001}</div>;
  }

  /**
   * ボタンエリア要素の描画
   *
   * @returns {Object} ボタンエリア要素
   * @memberof Header
   */
  renderButtonArea() {
    // 未ログインまたはlocalStorageに値をセットする前に描画処理が実行された場合の対応
    if (
      _.isEmpty(localStorage.getItem(ConstUtil.Common.STORAGE_KEY.AUTHORITY_ID))
    ) {
      return;
    }
    // Android と iOSの場合
    if (os === 'android' || os === 'ios') {
      return this.renderHamburgerMenu();
    }

    return (
      <div className="header-button-area">
        <mobiscroll.Button
          flat={true}
          icon="fa-user"
          onClick={this.clickButton}
        >
          {ConstUtil.Message.COMMON.ID002}
        </mobiscroll.Button>
        <mobiscroll.Button flat={true} icon="fa-sign-out" onClick={this.logout}>
          {ConstUtil.Message.COMMON.ID003}
        </mobiscroll.Button>
      </div>
    );
  }

  /**
   * メニュー要素の描画
   *
   * @returns {Object} メニュー要素
   * @memberof Header
   */
  renderMenu() {
    return <HeaderMenu />;
  }

  /**
   * メニューアイテムクリック
   *
   * @param {object} event
   * @param {object} inst
   * @memberof Header
   */
  clickHamburgerMenu(event, inst) {
    // 選択を解除する
    inst.deselect(event.target);
    if (event.target.dataset.id === ConstUtil.Common.PORTAL_URL_LIST.LOGIN) {
      this.logout();
      return;
    }
    let url = event.target.dataset.id;
    // リンクの場合
    if (url.indexOf(AppConfig.httpScheme) !== -1) {
      window.location.href = url;
      return;
    }
    this.props.history.push(url);
  }

  /**
   * ポータルトップのハンバーガーメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderPortalTopMenu() {
    return (
      <mobiscroll.NavItem
        id={
          AppConfig.httpScheme +
          AppConfig.portalDomain +
          AppConfig.appPortNumber +
          ConstUtil.Common.PORTAL_URL_LIST.HOME
        }
        icon="fa-home"
      >
        {ConstUtil.Message.COMMON.ID101}
      </mobiscroll.NavItem>
    );
  }

  /**
   * 予約状況のハンバーガーメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderRequestSelectMenu() {
    // 予約日・予約時間 表示モード取得
    let displayMode = localStorage.getItem(
      ConstUtil.Common.STORAGE_KEY.BOOKING_DISPLAY_MODE
    );
    let requestSelectUrl = ConstUtil.Common.COMPONENT.REQUEST_TIME_SELECT.URL;
    if (displayMode === ConstUtil.Common.BOOKING_DISPLAY_MODE_LIST.CALENDAR) {
      requestSelectUrl = ConstUtil.Common.COMPONENT.REQUEST_DATE_SELECT.URL;
    }
    return (
      <mobiscroll.NavItem id={requestSelectUrl} icon="calendar">
        {ConstUtil.Message.COMMON.ID103}
      </mobiscroll.NavItem>
    );
  }

  /**
   * 予約一覧画面（配送業者）のハンバーガーメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderRequestListMenu() {
    return (
      <mobiscroll.NavItem
        id={ConstUtil.Common.COMPONENT.REQUEST_LIST.URL}
        icon="fa-list-alt"
      >
        {ConstUtil.Message.COMMON.ID104}
      </mobiscroll.NavItem>
    );
  }

  /**
   * 混雑状況画面のハンバーガーメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderCongestionSituationListMenu() {
    return (
      <mobiscroll.NavItem
        id={ConstUtil.Common.COMPONENT.CONGESTION_SITUATION_LIST.URL}
        icon="foundation-alert"
      >
        {ConstUtil.Message.COMMON.ID114}
      </mobiscroll.NavItem>
    );
  }

  /**
   * 車両一覧画面のハンバーガーメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderCarListMenu() {
    return (
      <mobiscroll.NavItem
        id={
          AppConfig.httpScheme +
          AppConfig.portalDomain +
          AppConfig.appPortNumber +
          ConstUtil.Common.PORTAL_URL_LIST.CAR
        }
        icon="material-drive-eta"
      >
        {ConstUtil.Message.COMMON.ID106}
      </mobiscroll.NavItem>
    );
  }

  /**
   * ドライバー一覧画面のハンバーガーメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderDriverListMenu() {
    return (
      <mobiscroll.NavItem
        id={
          AppConfig.httpScheme +
          AppConfig.portalDomain +
          AppConfig.appPortNumber +
          ConstUtil.Common.PORTAL_URL_LIST.DRIVER
        }
        icon="users"
      >
        {ConstUtil.Message.COMMON.ID107}
      </mobiscroll.NavItem>
    );
  }

  /**
   * マイページ画面のハンバーガーメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderMyPageMenu() {
    return (
      <mobiscroll.NavItem
        id={ConstUtil.Common.COMPONENT.MY_PAGE.URL}
        icon="fa-user-circle-o"
      >
        {ConstUtil.Message.COMMON.ID002}
      </mobiscroll.NavItem>
    );
  }

  /**
   * ログアウトのハンバーガーメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderLogoutMenu() {
    return (
      <mobiscroll.NavItem
        id={ConstUtil.Common.PORTAL_URL_LIST.LOGIN}
        icon="fa-sign-out"
      >
        {ConstUtil.Message.COMMON.ID003}
      </mobiscroll.NavItem>
    );
  }

  /**
   * 予約割当画面のハンバーガーメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderBookingAssignMenu() {
    return (
      <mobiscroll.NavItem
        id={ConstUtil.Common.COMPONENT.BOOKING_ASSIGN.URL}
        icon="calendar"
      >
        {ConstUtil.Message.COMMON.ID105}
      </mobiscroll.NavItem>
    );
  }

  /**
   * 予約一覧画面（センター）のハンバーガーメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderBookingListMenu() {
    return (
      <mobiscroll.NavItem
        id={ConstUtil.Common.COMPONENT.BOOKING_LIST.URL}
        icon="fa-list-alt"
      >
        {ConstUtil.Message.COMMON.ID104}
      </mobiscroll.NavItem>
    );
  }

  /**
   * 受付一覧画面のハンバーガーメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderReceptionListMenu() {
    return (
      <mobiscroll.NavItem
        id={ConstUtil.Common.COMPONENT.RECEPTION_LIST.URL}
        icon="fa-list-alt"
      >
        {ConstUtil.Message.COMMON.ID113}
      </mobiscroll.NavItem>
    );
  }

  /**
   * 満空情報画面のハンバーガーメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderFullEmptyListMenu() {
    return (
      <mobiscroll.NavItem
        id={ConstUtil.Common.COMPONENT.FULL_EMPTY_LIST.URL}
        icon="foundation-alert"
      >
        {ConstUtil.Message.COMMON.ID120}
      </mobiscroll.NavItem>
    );
  }

  /**
   * 実績一覧画面のハンバーガーメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderAchievementListMenu() {
    return (
      <mobiscroll.NavItem
        id={ConstUtil.Common.COMPONENT.ACHIEVEMENT_LIST.URL}
        icon="fa-list-alt"
      >
        {ConstUtil.Message.ACHIEVEMENT_LIST.ID011}
      </mobiscroll.NavItem>
    );
  }

  /**
   * ユーザー一覧画面のハンバーガーメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderUserListMenu() {
    return (
      <mobiscroll.NavItem
        id={ConstUtil.Common.COMPONENT.USER_LIST.URL}
        icon="fa-user-plus"
      >
        {ConstUtil.Message.COMMON.ID118}
      </mobiscroll.NavItem>
    );
  }

  /**
   * 配送会社一覧画面のハンバーガーメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderContractorListMenu() {
    return (
      <mobiscroll.NavItem
        id={ConstUtil.Common.COMPONENT.CONTRACTOR_LIST.URL}
        icon="material-business"
      >
        {ConstUtil.Message.COMMON.ID119}
      </mobiscroll.NavItem>
    );
  }

  /**
   * バース設定画面のハンバーガーメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderBerthSettingMenu() {
    return (
      <mobiscroll.NavItem
        id={ConstUtil.Common.COMPONENT.BERTH_SETTING.URL}
        icon="fa-gear"
      >
        {ConstUtil.Message.COMMON.ID111}
      </mobiscroll.NavItem>
    );
  }

  /**
   * お知らせ一覧画面のハンバーガーメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderNoticeListMenu() {
    return (
      <mobiscroll.NavItem
        id={ConstUtil.Common.COMPONENT.CENTER_NOTICE_LIST.URL}
        icon="material-chat"
      >
        {ConstUtil.Message.COMMON.ID112}
      </mobiscroll.NavItem>
    );
  }

  /**
   * 配送業者権限のメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderContractorHamburgerMenu() {
    return (
      <div className="header-hamberger">
        <mobiscroll.HamburgerNav
          theme={ConstUtil.Common.THEME}
          lang={ConstUtil.Message.COMMON.ID401}
          onItemTap={this.clickHamburgerMenu}
        >
          {this.renderPortalTopMenu()}
          {this.renderRequestSelectMenu()}
          {this.renderRequestListMenu()}
          {this.renderCongestionSituationListMenu()}
          {this.renderCarListMenu()}
          {this.renderDriverListMenu()}
          {this.renderMyPageMenu()}
          {this.renderLogoutMenu()}
        </mobiscroll.HamburgerNav>
      </div>
    );
  }

  /**
   * ドライバー権限のメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderDriverHamburgerMenu() {
    return (
      <div className="header-hamberger">
        <mobiscroll.HamburgerNav
          theme={ConstUtil.Common.THEME}
          lang={ConstUtil.Message.COMMON.ID401}
          onItemTap={this.clickHamburgerMenu}
        >
          {this.renderPortalTopMenu()}
          {this.renderRequestSelectMenu()}
          {this.renderRequestListMenu()}
          {this.renderCongestionSituationListMenu()}
          {this.renderMyPageMenu()}
          {this.renderLogoutMenu()}
        </mobiscroll.HamburgerNav>
      </div>
    );
  }

  /**
   * センター管理者権限のメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderCenterManagerHamburgerMenu() {
    return (
      <div className="header-hamberger">
        <mobiscroll.HamburgerNav
          theme={ConstUtil.Common.THEME}
          lang={ConstUtil.Message.COMMON.ID401}
          onItemTap={this.clickHamburgerMenu}
        >
          {this.renderBookingAssignMenu()}
          {this.renderBookingListMenu()}
          {this.renderReceptionListMenu()}
          {this.renderCongestionSituationListMenu()}
          {this.renderFullEmptyListMenu()}
          {this.renderAchievementListMenu()}
          {this.renderUserListMenu()}
          {this.renderContractorListMenu()}
          {this.renderBerthSettingMenu()}
          {this.renderNoticeListMenu()}
          {this.renderMyPageMenu()}
          {this.renderLogoutMenu()}
        </mobiscroll.HamburgerNav>
      </div>
    );
  }

  /**
   * バース担当者権限のメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderBerthManagerHamburgerMenu() {
    return (
      <div className="header-hamberger">
        <mobiscroll.HamburgerNav
          theme={ConstUtil.Common.THEME}
          lang={ConstUtil.Message.COMMON.ID401}
          onItemTap={this.clickHamburgerMenu}
        >
          {this.renderBookingAssignMenu()}
          {this.renderBookingListMenu()}
          {this.renderReceptionListMenu()}
          {this.renderCongestionSituationListMenu()}
          {this.renderFullEmptyListMenu()}
          {this.renderAchievementListMenu()}
          {this.renderUserListMenu()}
          {this.renderContractorListMenu()}
          {this.renderBerthSettingMenu()}
          {this.renderNoticeListMenu()}
          {this.renderMyPageMenu()}
          {this.renderLogoutMenu()}
        </mobiscroll.HamburgerNav>
      </div>
    );
  }

  /**
   * バース作業員権限のメニューを描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderBerthWorkerHamburgerMenu() {
    return (
      <div className="header-hamberger">
        <mobiscroll.HamburgerNav
          theme={ConstUtil.Common.THEME}
          lang={ConstUtil.Message.COMMON.ID401}
          onItemTap={this.clickHamburgerMenu}
        >
          {this.renderBookingAssignMenu()}
          {this.renderBookingListMenu()}
          {this.renderReceptionListMenu()}
          {this.renderCongestionSituationListMenu()}
          {this.renderFullEmptyListMenu()}
          {this.renderAchievementListMenu()}
          {this.renderContractorListMenu()}
          {this.renderMyPageMenu()}
          {this.renderLogoutMenu()}
        </mobiscroll.HamburgerNav>
      </div>
    );
  }

  /**
   * ハンバーガーメニュー描画
   *
   * @returns {Object} ハンバーガーメニュー
   * @memberof Header
   */
  renderHamburgerMenu() {
    // 権限を取得
    let authorityId = localStorage.getItem(
      ConstUtil.Common.STORAGE_KEY.AUTHORITY_ID
    );
    switch (authorityId) {
      // 配送業者
      case ConstUtil.Common.AUTHORITY_LIST.CONTRACTOR:
        return this.renderContractorHamburgerMenu();
      // ドライバー
      case ConstUtil.Common.AUTHORITY_LIST.DRIVER:
        return this.renderDriverHamburgerMenu();
      // センター管理者
      case ConstUtil.Common.AUTHORITY_LIST.CENTER_MANAGER:
        return this.renderCenterManagerHamburgerMenu();
      // バース担当者
      case ConstUtil.Common.AUTHORITY_LIST.BERTH_MANAGER:
        return this.renderBerthManagerHamburgerMenu();
      // バース作業員
      case ConstUtil.Common.AUTHORITY_LIST.BERTH_WORKER:
        return this.renderBerthWorkerHamburgerMenu();
      default:
        return (
          <div className="header-hamberger">
            <mobiscroll.HamburgerNav
              theme={ConstUtil.Common.THEME}
              lang={ConstUtil.Message.COMMON.ID401}
              onItemTap={this.clickHamburgerMenu}
            >
              {this.renderMyPageMenu()}
              {this.renderLogoutMenu()}
            </mobiscroll.HamburgerNav>
          </div>
        );
    }
  }

  /**
   * ヘッダー参照取得
   *
   * @param {Object} node ノード情報
   * @returns
   * @memberof Header
   */
  getRefHeader(node) {
    if (_.isEmpty(node)) {
      return;
    }
    this.refHeader = node;
  }

  /**
   * 描画
   *
   * @returns {Object} 画面を構成する要素
   * @memberof Header
   */
  render() {
    return (
      <header className="center-header" ref={this.getRefHeader}>
        {this.renderSystemTitle()}
        {this.renderButtonArea()}
        {this.renderMenu()}
      </header>
    );
  }
}

Header.propTypes = {
  setHeight: PropTypes.func.isRequired,
  location: PropTypes.shape({ hash: PropTypes.string.isRequired }),
  history: PropTypes.shape({ push: PropTypes.func })
};
export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/js/component/core/Header.jsx